/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `m/s` - m/s
 * * `mm` - mm
 * * `mm/h` - mm/h
 * * `mm/hr` - mm/hr
 * @export
 */
export const RasterRainUnitsEnum = {
  M_S: "m/s",
  MM: "mm",
  MM_H: "mm/h",
  MM_HR: "mm/hr",
} as const;
export type RasterRainUnitsEnum = (typeof RasterRainUnitsEnum)[keyof typeof RasterRainUnitsEnum];

export function instanceOfRasterRainUnitsEnum(value: any): boolean {
  for (const key in RasterRainUnitsEnum) {
    if (Object.prototype.hasOwnProperty.call(RasterRainUnitsEnum, key)) {
      if (RasterRainUnitsEnum[key as keyof typeof RasterRainUnitsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RasterRainUnitsEnumFromJSON(json: any): RasterRainUnitsEnum {
  return RasterRainUnitsEnumFromJSONTyped(json, false);
}

export function RasterRainUnitsEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RasterRainUnitsEnum {
  return json as RasterRainUnitsEnum;
}

export function RasterRainUnitsEnumToJSON(value?: RasterRainUnitsEnum | null): any {
  return value as any;
}

export function RasterRainUnitsEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): RasterRainUnitsEnum {
  return value as RasterRainUnitsEnum;
}
